(function () {
  function initCollectionTabGrid(sectionEl) {
    var section = sectionEl || document.querySelector('.oddit-section-collection-tab-grid');
    if (!section) return;

    // Tab switching
    var tabs = section.querySelectorAll('.oddit-section-collection-tab-grid__tab');
    var panels = section.querySelectorAll('[data-tab-content]');
    var ctaDesktop = section.querySelector('[data-cta]');
    var ctaMobile = section.querySelector('[data-cta-mobile]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var tabId = tab.getAttribute('data-tab');

        // Update active tab
        tabs.forEach(function (t) {
          t.classList.remove('oddit-section-collection-tab-grid__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('oddit-section-collection-tab-grid__tab--active');
        tab.setAttribute('aria-selected', 'true');

        // Show/hide tab panels
        panels.forEach(function (panel) {
          if (panel.getAttribute('data-tab-content') === tabId) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });

        // Update CTA text and link from data attributes
        var ctaLabel = tab.getAttribute('data-cta-label');
        var ctaLink = tab.getAttribute('data-cta-link');

        if (ctaDesktop) {
          ctaDesktop.textContent = ctaLabel;
          ctaDesktop.setAttribute('href', ctaLink || '#');
        }
        if (ctaMobile) {
          ctaMobile.textContent = ctaLabel;
          ctaMobile.setAttribute('href', ctaLink || '#');
        }

        // Reset carousel to page 0 for new tab
        currentPage = 0;
        var activeGrid = getActiveGrid();
        if (activeGrid) {
          activeGrid.scrollTo({ left: 0, behavior: 'instant' });
        }
        updateDots();
      });
    });

    // Carousel functionality (desktop)
    var prevBtn = section.querySelector('.oddit-section-collection-tab-grid__arrow--prev');
    var nextBtn = section.querySelector('.oddit-section-collection-tab-grid__arrow--next');
    var dots = section.querySelectorAll('.oddit-section-collection-tab-grid__dot');
    var totalPages = dots.length;
    var currentPage = 0;

    function getActiveGrid() {
      return section.querySelector('[data-tab-content]:not([hidden])');
    }

    function scrollToPage(page) {
      if (page < 0) page = 0;
      if (page >= totalPages) page = totalPages - 1;
      currentPage = page;

      var grid = getActiveGrid();
      if (!grid) return;

      if (page === 0) {
        grid.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        grid.scrollTo({ left: grid.scrollWidth - grid.clientWidth, behavior: 'smooth' });
      }

      updateDots();
    }

    function updateDots() {
      dots.forEach(function (dot, index) {
        dot.classList.toggle(
          'oddit-section-collection-tab-grid__dot--active',
          index === currentPage
        );
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollToPage(currentPage - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToPage(currentPage + 1);
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        scrollToPage(index);
      });
      dot.style.cursor = 'pointer';
    });

    // Update current page on scroll
    function bindGridScroll(grid) {
      if (!grid) return;
      var scrollTimeout;
      grid.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          var maxScroll = grid.scrollWidth - grid.clientWidth;
          if (maxScroll <= 0) return;
          var newPage = grid.scrollLeft > maxScroll * 0.5 ? 1 : 0;
          if (newPage !== currentPage) {
            currentPage = newPage;
            updateDots();
          }
        }, 100);
      });
    }

    // Bind scroll events to all grids
    panels.forEach(function (panel) {
      bindGridScroll(panel);
    });
  }

  // Initialize
  initCollectionTabGrid();

  // Theme editor support
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.oddit-section-collection-tab-grid');
      if (section) {
        initCollectionTabGrid(section);
      }
    });
  }
})();